import styled from 'styled-components';

export const StyledWeatherNormalCardTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #2f2f35;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StyledWeatherNormalCardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .content {
    font-size: 28px;
    font-weight: 500;
    color: #585959;
  }

  .pm {
    font-size: 18px;
    font-weight: 400;
    color: #585959;
  }

  .pm2_5 {
    /* color: #660099; */
    color: #585959;
  }

  .pm10 {
    /* color: #720023; */
    color: #585959;
  }
`;
